import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface ExpiredContractDialogProps {
  /** Whether the dialog is open */
  open: boolean;
  /** Handler for dialog open/close state changes */
  onOpenChange: (open: boolean) => void;
  /** Handler for when user confirms and wants to proceed */
  onConfirm: () => void;
  /** Phone number to display for support (optional, defaults to 801-563-4187) */
  phoneNumber?: string;
}

/**
 * Dialog component that warns users when they have selected expired contracts
 * and provides support contact information.
 */
export function ExpiredContractDialog({
  open,
  onOpenChange,
  onConfirm,
  phoneNumber = '801-563-4187',
}: ExpiredContractDialogProps) {
  const handleConfirm = () => {
    onOpenChange(false);
    onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-sm p-4'>
        <DialogHeader className='space-y-3'>
          <DialogTitle className='text-primary text-lg font-semibold'>
            Expired Contract Notice
          </DialogTitle>
          <DialogDescription className='text-foreground text-sm leading-relaxed space-y-2'>
            <p>One or more of the contracts you&apos;ve selected is expired.</p>
            <p>
              If you have any questions, call{' '}
              <a
                href={`tel:${phoneNumber}`}
                className='font-semibold text-primary hover:text-accent underline'
              >
                {phoneNumber}
              </a>
            </p>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className='sm:justify-center pt-2'>
          <Button onClick={handleConfirm} size='sm'>
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
